import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import { Typography, IconButton, Input, Box } from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import axios from "../../../../lib/axios";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import ConfirmationDialog from '../../../ReusableDailog';
import AddIcon from '@mui/icons-material/Add';
import { useReactToPrint } from 'react-to-print';
import RecipeFood from './RecipeFood';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import IngredientsBOM from './IngredientsBOM';
import UpdateBomQty from '../UpdateQty/UpdateBomQty';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'FoodName', label: 'Food', minWidth: 100 },
    { id: 'FoodGrpName', label: 'Group', minWidth: 100 },
    { id: 'FoodSubGrpName', label: 'SubGroup', minWidth: 100 },
    { id: 'FoodClsName', label: 'Food Class', minWidth: 100 },
    { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const RecipeBom = () => {
    const [formData, setFormData] = useState({
        FoodId: null,
        FoodName: '',
        FoodGrpId: '',
        FoodSubGrpId: '',
        FoodBomId: '',
        FoodBomImg: '',
        FoodClsId: '',
        UnitId: '',
        Abrv: '',
        SplPrice: '0.00',
        Price: '0.00',
        Remark: '',
        StdQty: '1.00',
        Status: ''
    });

    const [error, setError] = useState({
        FoodName: false,
        FoodGrpName: false
    });

    const navigate = useNavigate();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const location = useLocation();
    const [currentFoodId, setCurrentFoodId] = useState(null);
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [lastInsertedFoodId, setLastInsertedFoodId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const FoodNameRef = useRef(null);
    const FoodGrpNameRef = useRef(null);
    const remarkRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [bomItems, setBomItems] = useState([]);
    const [bomRows, setBomRows] = useState([]);
    const [image, setImage] = useState(null);
    const [imgName, setImgName] = useState(null);
    const [searchText, setSearchText] = useState('');

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result);
                setImgName(file.name);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleRemoveImage = () => {
        setImage(null);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (location.state) {
            const { FoodBomId, mode } = location.state;

            if (FoodBomId) {
                setCurrentFoodId(FoodBomId);
                setMode(mode || 'view');
                fetchBomDetails(FoodBomId);
            } else {
                setMode('add');
                setIsFormDisabled(false);
                setBomRows([{
                    id: Date.now(),
                    ingredient: null,
                    qty: '',
                    unit: '',
                    extraQty: '',
                }]);
            }
        }
    }, [location]);

    const fetchBomDetails = async (bomId, flag) => {
        try {
            setIsFormDisabled(true);
            const response = await axiosInstance.post(`MstFood/RetriveMstFoodBomAll`, {
                FoodBomId: parseInt(bomId),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const coMstList = response.data.Data?.CoMstList || [];

                if (coMstList.length === 0) {
                    toast.error("No BOM data found for this record");
                    return;
                }

                const data = coMstList[0];

                const fixedImageUrl = data.FoodBomImg.startsWith('http:/')
                    ? data.FoodBomImg.replace('http:/', 'http://')
                    : data.FoodBomImg;

                setFormData({
                    FoodId: data.FoodId,
                    FoodName: data.FoodName || '',
                    FoodGrpId: data.FoodGrpId || '',
                    FoodGrpName: data.FoodGrpName || '',
                    FoodSubGrpId: data.FoodSubGrpId || '',
                    FoodSubGrpName: data.FoodSubGrpName || '',
                    FoodClsId: data.FoodClsId || '',
                    FoodClsName: data.FoodClsName || '',
                    FoodBomId: data.FoodBomId || bomId,
                    FoodBomImg: fixedImageUrl || '',
                    UnitId: data.UnitId || '',
                    UnitName: data.UnitName || '',
                    StdQty: data.StdQty?.toString() || '1.00',
                    Abrv: data.Abrv || '',
                    Remark: data.Remark || '',
                    SplPrice: data.SplPrice?.toString() || '0.00',
                    Price: data.Price?.toString() || '0.00',
                    Status: data.Status?.toString() || '1',
                });

                setStatus(data.Status?.toString() || '1');

                const bomDetailList = data.FoodBomDTLList || [];

                if (bomDetailList.length > 0) {
                    const formattedBomRows = bomDetailList.map((item) => ({
                        id: Date.now() + Math.random(),
                        ingredient: {
                            ItmId: item.ItmId,
                            ItmName: item.ItmName || '',
                            UnitId: item.UnitId,
                            UnitName: item.UnitName || ''
                        },
                        qty: item.Qty?.toString() || '',
                        unit: item.UnitName || '',
                        extraQty: item.ExQty?.toString() || '',
                        originalDetailId: item.FoodBomDtlId || 0,
                    }));

                    setBomRows(formattedBomRows);
                } else {
                    setBomRows([{
                        id: Date.now(),
                        ingredient: null,
                        qty: '',
                        unit: '',
                        extraQty: '',
                    }]);
                }
            }
        } catch (error) {
            toast.error("Failed to load BOM details");
        }
    };

    useEffect(() => {
        const getRow = async () => {
            try {
                const res = await axios.post('MstFood/GetMstFoodBomDashBoard', {
                    start: 1,
                    PageSize: 1,
                    SearchText: ""
                });
                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                }
            } catch (err) {
                toast.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    const handlePrevious = async () => {
        if (currentFoodId && currentFoodId > 1) {
            await fetchBomDetails(currentFoodId, "P");
        }
    };

    const handleNext = async () => {
        if (currentFoodId) {
            await fetchBomDetails(currentFoodId, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === FoodNameRef.current) {
                FoodGrpNameRef.current.focus();
            } else {
                remarkRef.current.focus();
            }
        }
    };

    const handleSubmit = async () => {

        let hasError = false;
        if (!formData.FoodId || formData.FoodId === 0) {
            toast.error("Please select food first.");
            hasError = true;
        }

        if (hasError) return;

        const mstFoodEntities = bomRows
            .filter((r) => r.ingredient)
            .map((r) => ({
                DBFLAG: r.isDeleted ? "D" : (r.originalDetailId ? "U" : "I"),
                FoodBomDtlId: r.originalDetailId || 0,
                FoodBomId: formData.FoodBomId || 0,
                ItmId: r.ingredient.ItmId,
                Qty: parseFloat(r.qty) || 0,
                ExQty: parseFloat(r.extraQty) || 0,
                ExPerc: 0,
                UnitId: r.ingredient.UnitId || 0,
                Remark: "",
            }));

        const payload = {
            FoodId: formData.FoodId,
            StdQty: parseFloat(formData.StdQty) || 1,
            UnitId: parseInt(formData.UnitId) || 0,
            Remark: formData.Remark || "",
            Status: Status,
            CreatedBy: parseInt(UserId, 10),
            FoodBomImg: image || '',
            ImgName: imgName || '',
            DBFLAG: mode === "add" ? "I" : "U",
            mstFoodEntities: mstFoodEntities,
        };

        try {
            const response = await axiosInstance.post("MstFood/MangeMstFoodBom",
                payload
            );

            if (response.data.Status === 0) {
                toast.success("Record saved successfully" || response.data.Message);

                if (mode === "add") {
                    setFormData((prevState) => ({
                        ...prevState,
                        FoodBomId: response.data.Data?.FoodBomId,
                    }));
                    await fetchBomDetails(response.data.Data?.FoodBomId);
                }

                setMode("view");
                setIsFormDisabled(true);
            } else {
                toast.info(response.data.Message || "Failed to save BOM");
            }
        } catch (error) {
            toast.error("Error saving BOM. Please try again.");
        }
    };

    const handleEdit = async () => {
        let Flag = await checkAndLock(currentFoodId, "MstFood", "FoodId");
        switch (Flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            FoodName: '',
            FoodGrpId: '',
            FoodSubGrpId: '',
            FoodClsId: '',
            FoodBomId: '',
            Abrv: '',
            SplPrice: '0.00',
            Price: '0.00',
            UnitId: '1',
            Remark: '',
            Status: ''
        });
        setCurrentFoodId(null);

        setBomRows([{
            id: Date.now(),
            ingredient: null,
            qty: '',
            unit: '',
            extraQty: '',
        }]);
    };

    const handleCancel = async () => {
        try {
            await fetchBomDetails(1, "L");
            await UnLock(currentFoodId, "MstFood", "FoodId");
            setStatus("1");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const handleExit = () => {
        navigate('/recipe-bomtable')
    }

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        setOpenConfirmDialog(false);
        const response = await axiosInstance.post("MstFood/DeleteMstFoodBom", {
            FoodBomId: currentFoodId,
            Flag: 'R'
        });
        if (response.data.Status === 0) {
            toast.success(response.data.Message || 'Record Deleted.');
            await fetchBomDetails(currentFoodId, "P");
            setStatus("1");
            setMode('view');
            setIsFormDisabled(true);
        } else {
            toast.warn(response.data.Message || 'Failed to delete the record.');
        }
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    return (
        <>
            <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
                {/* <ToastContainer /> */}
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentFoodId || currentFoodId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentFoodId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Recipe Ingredients
                        </Typography>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName={"Recipe Ingredients"}
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_field'>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={9} lg={10}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} md={4} lg={4}>
                                        <TextField
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            label="Food Group"
                                            value={formData.FoodGrpName || ''}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={4}>
                                        <TextField
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            label="SubGroup"
                                            value={formData.FoodSubGrpName || ''}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={2}>
                                        <TextField
                                            id="FoodBomId"
                                            name="FoodBomId"
                                            label="BomId"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={formData.FoodBomId || 'Auto'}
                                            onChange={handleInputChange}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={2}>
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={handleClickOpen}
                                            disabled={isFormDisabled}
                                            sx={{
                                                background: "#635bff",
                                                color: "white",
                                                padding: "6px 15px",
                                                textTransform: 'none',
                                                "&:hover": {
                                                    background: "#635bff"
                                                }
                                            }}
                                        >
                                            <AddIcon fontSize="small" sx={{ mr: 0.5 }} /> Add Item
                                        </Button>
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={8}>
                                        <TextField
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            label="Food Name"
                                            value={formData.FoodName || ''}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={2}>
                                        <TextField
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            label="StdQty"
                                            value={formData.StdQty || '1.00'}
                                            onChange={handleInputChange}
                                            name="StdQty"
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={1.4}>
                                        <TextField
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            label="Unit"
                                            value={formData.UnitName || ''}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={11.4}>
                                        <TextField
                                            id="Remark"
                                            name="Remark"
                                            label="Remark"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={formData.Remark}
                                            onChange={handleInputChange}
                                            disabled={isFormDisabled}
                                            inputRef={remarkRef}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={3} lg={2}>
                                <Box
                                    sx={{
                                        position: 'relative',
                                        width: '100%',
                                        height: '140px',
                                        overflow: 'hidden',
                                        border: '1px solid #ddd',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        boxSizing: 'border-box',
                                    }}
                                >
                                    <Input
                                        type="file"
                                        inputProps={{ accept: 'image/*' }}
                                        onChange={handleImageChange}
                                        sx={{ display: 'none' }}
                                        id="image-upload"
                                        disabled={isFormDisabled}
                                    />

                                    {image || formData.FoodBomImg ? (
                                        <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                                            <img
                                                src={image || formData.FoodBomImg}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    borderRadius: '8px',
                                                    display: 'block',
                                                }}
                                                alt="No Image"
                                            />
                                            {!isFormDisabled && (
                                                <IconButton
                                                    onClick={handleRemoveImage}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '2px',
                                                        right: '5px',
                                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                        color: 'white',
                                                        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                                                        fontSize: '16px',
                                                    }}
                                                >
                                                    <DeleteIcon sx={{ fontSize: '16px' }} />
                                                </IconButton>
                                            )}
                                        </Box>
                                    ) : (
                                        !isFormDisabled && (
                                            <label htmlFor="image-upload">
                                                <IconButton
                                                    component="span"
                                                    sx={{
                                                        background: "#635bff",
                                                        color: 'white',
                                                        '&:hover': { background: '#524ccc' },
                                                    }}
                                                >
                                                    <AddPhotoAlternateIcon />
                                                </IconButton>
                                            </label>
                                        )
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_field'>
                        <IngredientsBOM
                            rows={bomRows}
                            setRows={setBomRows}
                            mode={mode}
                        // items={items}
                        />
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        <Button variant="contained" sx={{ mr: 1, background: '#635bff', ':hover': { backgroundColor: '#635bff' } }}
                            disabled={mode === 'add' || formData.FoodBomId === 0}
                            onClick={() => {
                                if (!formData.FoodBomId) {
                                    toast.warn("No BOM loaded. Please select or save a recipe first.");
                                    return;
                                }
                                const url = `/basicratio?foodBomId=${formData.FoodBomId}`;
                                window.open(url, '_blank');
                            }}
                        >
                            Base Qty
                        </Button>
                        <Button variant="contained" sx={{ mr: 1, background: '#635bff', ':hover': { backgroundColor: '#635bff' } }}
                            disabled={mode === 'add' || formData.FoodBomId === 0}
                            onClick={() => {
                                if (!formData.FoodBomId) {
                                    toast.warn("No BOM loaded. Please select or save a recipe first.");
                                    return;
                                }
                                const url = `/updatebomqty?foodBomId=${formData.FoodBomId}`;
                                window.open(url, '_blank');
                            }}
                        >
                            Fill Std Qty
                        </Button>
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title="Recipe Ingredients"
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />}
            </div>

            <ConfirmationDialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                onConfirm={handleConfirmDelete}
                title="Confirm Deletion"
                message="Are you sure you want to delete this record.?"
            />

            <Dialog open={open} onClose={handleClose} fullWidth maxWidth='md'>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: 'auto', py: 1.5 }}>
                    <Typography variant="h5">Recipe Food</Typography>

                    <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto' }}>
                        <TextField
                            placeholder="Search Food..."
                            value={searchText}
                            onChange={handleSearchChange}
                            sx={{
                                mr: 1,
                                width: '200px',
                                borderRadius: '20px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '20px',
                                },
                            }}
                        />
                        <IconButton onClick={handleClose} sx={{ padding: 0 }}>
                            <CloseIcon color="error" />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ maxHeight: 400, overflowY: 'auto' }}>
                    <div id="recipe-food-table">
                        <RecipeFood
                            onSelectFood={(selectedFood) => {
                                setFormData(prev => ({
                                    ...prev,
                                    FoodId: selectedFood.FoodId,
                                    FoodName: selectedFood.FoodName || '',
                                    Abrv: selectedFood.Abrv || '',
                                    FoodGrpId: selectedFood.FoodGrpId || '',
                                    FoodGrpName: selectedFood.FoodGrpName || '',
                                    FoodSubGrpId: selectedFood.FoodSubGrpId || '',
                                    FoodSubGrpName: selectedFood.FoodSubGrpName || '',
                                    UnitId: selectedFood.UnitId || '',
                                    UnitName: selectedFood.UnitName || '',
                                    StdQty: "1.00",
                                    StdQty: selectedFood.StdQty || "1.00",
                                }));

                                handleClose();
                            }}
                            searchText={searchText}
                        />
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default RecipeBom;